import ThankYouForReview from './ThankYouForReview';
export default ThankYouForReview;